import axios from "axios";
import GetAllStoresModel from "./GetAllStoresModel";


export default class GetAllStoresViewModel {
   allstorelist : GetAllStoresModel[];
    totalPages: number;
    totalCount : number;

    constructor()
 {
   this.allstorelist=[];
   this.totalCount=0;
   this.totalPages=0;
 }
    async LoadAllStoreList(pageNumber: number, pageSize: number, partnerid:any,status: string,filterbyid:any){

        try {
            const API_URL = process.env.REACT_APP_API_URL
            const idToken : string | null = localStorage.getItem("IdToken");
            const response = await axios.get(`${API_URL}/v1/partners/${partnerid}/allstores`, {
                params: {
                    page: pageNumber,
                    pageSize: pageSize,
                    status:status,
                    filterbyid:filterbyid,
                 
                },
                headers:{
                    'Authorization': `${idToken}`
                }
            });
  
            const data = response.data.response.items;
            this.allstorelist = data;
            this.totalPages = response.data.response.totalPages
            this.totalCount= response.data.response.totalCount
        } catch (error) {
            console.error('Failed to load Stores list data:', error);
        }

    }
}
